import { render, staticRenderFns } from "./ViewGallery.vue?vue&type=template&id=b96338de&scoped=true"
import script from "./ViewGallery.vue?vue&type=script&lang=js"
export * from "./ViewGallery.vue?vue&type=script&lang=js"
import style0 from "./ViewGallery.vue?vue&type=style&index=0&id=b96338de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96338de",
  null
  
)

export default component.exports